'use strict';

const AI_BUSINESS_CASES = {
  ANALYZE_ACCOUNT: 'analyze_account',
  ANALYZE_CONTACT: 'analyze_contact',
  CATEGORIZE_EMAIL_REPLY: 'categorize_email_reply',
  DETECT_BOUNCE_EMAIL: 'detect_bounce_email',
  ENGAGE_CONTACT: 'engage_contact',
  GENERATE_EMAIL_SUBJECT: 'generate_email_subject',
  GENERATE_VALUE_PROPOSITION: 'generate_value_proposition',
};

const AI_EMAIL_CATEGORIES = {
  BLOCKED: {
    ID: 6,
    LABEL: 'blocked',
  },
  BOUNCE: {
    ID: 5,
    LABEL: 'bounce',
  },
  // Représente une erreur lors de la tentative de catégorisation (échec du prompt, erreur réseau, etc.)
  ERROR: {
    ID: 0,
    LABEL: 'erreur',
  },
  REPLIED: {
    ID: 7,
    LABEL: 'reply',
  },
  REPLY_AUTO: {
    ID: 3,
    LABEL: 'réponse automatique',
  },
  REPLY_INTERESTED: {
    ID: 1,
    LABEL: 'intéressé(e)',
  },
  REPLY_NOT_INTERESTED: {
    ID: 2,
    LABEL: 'pas intéressé(e)',
  },
  REPLY_OTHER: {
    ID: 4,
    LABEL: 'autre',
  },
};

export {
  AI_BUSINESS_CASES,
  AI_EMAIL_CATEGORIES,
};
